module.exports = __webpack_public_path__ + "img/type_40_0.prt.721024b3.jpg";